import Vue from 'vue';
import _ from 'lodash';

export default Vue.component('dynamic-input-checkbox', {
  template: require('./template.html'),
  name: 'dynamic-input-checkbox',
  props: [
    'active-item',
    'type',
    'value',
    'inner-tabs',
    'dynamic-tab',
    'open-cropper',
  ],
  data() {
    return {
      display: {},
    };
  },
  watch: {
    innerTabs: {
      handler(tab) {
        if (tab[this.dynamicTab]) {
          this.setInitialValues();
        }
      },
      deep: true,
    },
  },
  methods: {
    setInitialValues() {
      this.$set(this.display, this.type, this.activeItem[this.type]);
    },
    startCase(text) {
      return _.startCase(text);
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/edit-item/inputs/checkbox/index.js